import React, { Component } from 'react';
class Parallax extends Component {
    render() {
        return (
            <div className="page-title parallax parallax1">
                        <div className="overlay"></div>
                        <div className="container">
                            <div className="flat-talk">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="title-section style1">
                                            <p>To help entrepreneurs get their act together</p>
                                            <p><span>before they talk </span> to investors.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- row --> */}
                            </div>
                            {/* <!-- flat-talk --> */}
                        </div>
                        {/* <!-- container --> */}
                    </div>
                /* <!-- page-title --> */  
        );
    }
}

export default Parallax;